// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Jersey */
const JE = /^(?:7(?:(?:(?:50|82)9|937)\d|7(?:00[378]|97\d))\d{5})$/;

export default JE;
